var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-provider"},[_c('NotificationCenter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }